import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { EntitySetting } from "../models/entity-setting.model";

@Injectable({
  providedIn: "root",
})
export class EntitySettingsService {
  private readonly ROOT = "settings";

  constructor(private http: HttpClient) {}

  getSetting(
    modelName: string,
    modelId: number,
    name: string
  ): Observable<EntitySetting> {
    const params = new HttpParams()
      .set("model_name", modelName)
      .set("model_id", String(modelId));

    return this.http
      .get<{ result: EntitySetting }>(
        `${environment.gateway_endpoint}${this.ROOT}/${name}`,
        { params }
      )
      .pipe(map((response) => response.result));
  }

  updateSetting(
    modelName: string,
    modelId: number,
    name: string,
    value: string | string[]
  ): Observable<EntitySetting> {
    return this.http
      .put<{ result: EntitySetting }>(
        `${environment.gateway_endpoint}${this.ROOT}/${name}`,
        {
          model_name: modelName,
          model_id: modelId,
          name,
          value,
        }
      )
      .pipe(map((response) => response.result));
  }
}
